/**
 @ngdoc service
 @name mapTimebasedalertTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapTimebasedalertTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('recordType', 'recordTypeURI'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('recordID'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('recordName'));

            tileFactory.addFieldToColumn2(tileFactory.field.newField('dateCreated', 'dateTime'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('createdBy'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('assignedToName'));

            tileFactory.addFieldToColumn3(tileFactory.field.newField('scheduledDate', 'dateTime'));

            var repeat;
            var period;
            var count;
            if(rawTileData.repeatPeriod == 1){
                count = '';
                if(rawTileData.repeatPeriodId == 330){
                    period = 'day';
                }else if (rawTileData.repeatPeriodId == 331){
                    period = 'week';
                }else{
                    period = 'month';
                }
            }else if (rawTileData.repeatPeriod > 1){
                count = rawTileData.repeatPeriod + ' ';
                if(rawTileData.repeatPeriodId == 330){
                    period = 'days';
                }else if (rawTileData.repeatPeriodId == 331){
                    period = 'weeks';
                }else{
                    period = 'months';
                }
            }
            if(rawTileData.repeatChecked){
                repeat = 'Every ' + count + period;
            }else{
                repeat = 'None';
            }
            tileFactory.addFieldToColumn3({label: objectTilesLabels.repeat.label, value: repeat});
            var level;
            if(rawTileData.isPersonal){
                level = objectTilesLabels.levelPersonal.label;
            }else{
                level = objectTilesLabels.levelAssigned.label;
            }
            tileFactory.addFieldToColumn3({label: objectTilesLabels.level.label, value: level});

            tileFactory.addFieldToColumn4(tileFactory.field.newField('message'));

            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapTimebasedalertTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapTimebasedalertTileService', mapTimebasedalertTileService);
}());